import React, { useState, useEffect } from "react";
import { Calendar } from "react-multi-date-picker";
import { Modal, Button } from "react-bootstrap";
import { reportService } from "../../../Services/report.service";
import { ToastComponent } from "../ToastComponent";

export default function DatePickModal({ show, dateValue, title, handleClose, reportId }) {
    const [date, setDate] = useState(dateValue);
    const [isLoading, setIsLoading] = useState(false);
    const [toastParams, setToastParams] = useState("")

    const handleDateChange = async (selectedDates) => {
        try {
            // Verifica se o reportId é 0
            if (reportId === 0) {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Ação não permitida",
                        body: "É necessário solicitar o relatório antes de selecionar uma data.",
                        color: "warning",
                    })
                );
                return;
            }

            setDate(selectedDates);

            // Se não tem datas selecionadas, retorna
            if (!selectedDates || selectedDates.length === 0) {
                return;
            }

            } catch (error) {
            console.error("Erro ao adicionar data:", error);
            setToastParams(
                JSON.stringify({
                    show: true,
                    title: "Ação não permitida",
                    body: "É necessário solicitar o relatório antes de selecionar uma data.",
                    color: "warning",
                })
            );
            // Remove a última data se deu erro
            setDate((prev) => prev.slice(0, -1));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Atualiza o estado com a data inicial, se fornecida
        if (dateValue) {
            setDate(dateValue);
        }
    }, [dateValue]);

    return (
        <>
            <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />
        <Modal show={show} onHide={() => handleClose(date)} contentClassName="modal-date-content">

            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                <Calendar
                    multiple
                    value={date}
                    onChange={handleDateChange} // Chama a função ao selecionar uma data
                />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleClose(date);
                    }}
                >
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
        
        </>
    );
}
